import React, { Component, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import ContentWrapper from "../../../../../components/common/ContentWrapper.js";
import Card from "../../../../../components/common/Card.js";
import Col from "react-bootstrap/Col";
import { GoCheckbox } from "react-icons/go";
import CardHeader from "../../../../../components/common/CardHeader.js";
import CardBody from "../../../../../components/common/CardBody.js";
import LocalMallOutlinedIcon from '@mui/icons-material/LocalMallOutlined';
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormGroup from "../../../../../components/common/form/FormGroup.js";
import { CombankService } from "../../../../../service/manage/subscription/combank_pg.service.js";
import moment from "moment";
import Row from "react-bootstrap/Row";
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Checkbox,
  Box
} from "@mui/material";
import MaterialCustomTablePagination from "../../../../../components/common/MaterialCustomTablePagination.js";
import debounce from "lodash.debounce";
import { history } from "../../../../../helper/history.js";
import { PaperService } from "../../../../../service/manage/paper/paper_service.js";
import {
  sweetAlertEnroll,
  sweetStatusAlert
} from "../../../../../components/common/SweetAlert.js";
import PageSpinner from "../../../../../components/common/spinner/PageSpinner.js";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import { StudentService } from "../../../../../service/manage/registration/student.service.js";
import { EnrolledPaperService } from "../../../../../service/manage/paper/enrolled_paper.service.js";
import { Button } from "react-bootstrap";
import Chip from "@mui/material/Chip";
import { assessmentService } from "../../../../../service/assessment/assessmentService.js";
import { ASSESSMENT_FILTERS } from "../../../../../helper/constants.js";
import { CreditService } from "../../../../../service/manage/subscription/credit.service.js";
import { AssessmentCreditService } from "../../../../../service/manage/exam_subscription/assessCredit.service.js";
import TimeZoneHandler from "../../../../../handlers/TimeZoneHandler.js";
import config from "../../../../../helper/config.js";
import { customerConstants } from "../../../../../helper/constants.js";
import { GradeService } from "../../../../../service/settings/manage/grade.service.js";
import { assessSubjectService } from "../../../../../service/settings/assessment/subjectService.js";
import { assessYearService } from "../../../../../service/settings/assessment/yearService.js";
import { libraryService } from "../../../../../service/assessment/libraryService.js";
import { creditCategoryService } from "../../../../../service/settings/manage/credit_category.service.js";
import ReactSpinner from "react-bootstrap/Spinner";
import { routes } from "../../../../../helper/routes.js";
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Radio, Sheet } from '@mui/joy';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import "./Paper.css";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FormControlLabel from "@mui/material/FormControlLabel";
import PaperListChips from "./PaperListChips.js";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { styled } from '@mui/material/styles';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TuneRoundedIcon from '@mui/icons-material/TuneRounded';
import PaymentGateSolutions from '../../img/Payment Gateway Solutions.jpg';
import PaperFilterLayout from '../TheFilter/PaperFilterLayout.js'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import { unitConstants } from "../../../../../helper/constants.js";
import { ASSESSMENT_STUDENT_FILTERS } from "../../../../../helper/constants.js";

const getCustomerFeatureFlag = () => {
  return config.customerConfigs.featureFlag;
};

const customer = getCustomerFeatureFlag();
// Customer-specific button styling is handled via CSS classes.
// Add `cmc-enroll` to enroll buttons and `cmc-close` to close buttons when customer === customerConstants.EXO_CUSTOMER2.


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

export default class EdPaperList extends Component {

  constructor(props) {
    super(props);

    this.state = {
      userType: null,
      userId: "",
      node_mid: null,
      papers: [],
      enrolledPapers: [],
      limit: 10,
      offset: 0,
      search_term: "",
      breadcrumb2: null,
      nodeTitle: null,
      totalPapers: 0,
      currentPage: 0,
      selectedCredits: [],
      totalSelectedCredits: 0,
      isCreditSufficient: false,
      sortColumn: "assess_name",
      sortDirection: "desc",
      selectedStudent: "",
      studentlist: [],
      isTableDataLoading: true,
      isSpinnerLoading: false,
      isDropHidden: false,
      assessment_name: "",
      editVisibility: false,
      addVisibility: false,
      deleteVisibility: false,
      viewVisibility: false,
      create_user_id: "",
      create_user_table_id: "",
      filterValues: [],
      filters: [],
      selectedFilters: [],
      selectedGrades: null,
      selectedChapters: null,
      selectedsubjects: null,
      selectedAuthors: null,
      selectedYears: null,
      selectedCategories: null,
      selectedTerms: null,
      selectedDifficulties: null,
      selectedLanguages: null,
      examData: [],
      allUnits: [],
      allCategories: [],
      allLanguages: [],
      allSubjects: [],
      allAuthors: [],
      allYears: [],
      allDifficulties: [],
      allGrades: [],
      allTerms: [],
      allChapters: [],
      allCurrencyTypes: [],
      showInsertModal: false,
      showCreditInsertModal: false,
      showCreditBuyModal: false,
      credits: [],
      creditsAssessments: [],
      assessmentCredits: null,
      credit_id: "",
      selectedCredit: null,
      isCreditNotAvailable: false,
      isModified: false,
      asses_id: null,
      assess_name: null,
      assess_credits: null,
      credit_purchase_flag: null,
      amount_purchase_flag: null,
      no_of_credits: null,
      amount: null,
      amount_currency_type_id: 1,
      grade_id: "",
      is_level_price_loading: false,
      creditsLoading: false,
      grades: [],
      subjects: [],
      years: [],
      isGradeLoading: false,
      isSubjectLoading: false,
      isYearLoading: false,
      selectedPaper: false,
      isFilterCollapsed: false
    };

    this.debouncedHandleSearch = debounce(this.callAfterSubmit, 2000);
  }

  componentDidMount() {

    const {
      lg_user_id,
      lg_user_table_id,
      flg_list_active,
      privilage_view,
      privilege_add,
      privilege_edit,
      nodeTitle,
      breadcrumb2,
      privilege_delete,
    } = this.props.state;

    this.getVisibilityCheck(
      privilage_view,
      privilege_add,
      privilege_delete,
      privilege_edit
    );
    this.setState({
      breadcrumb2: breadcrumb2,
      nodeTitle: nodeTitle,
    });
    let userType = sessionStorage.getItem("userType");
    this.setState({ userType });

    this.getAllGrades();
    this.getAllSubjects();
    this.getAllYears();

    if (userType === "admin") {
      if (flg_list_active === 1) {
        this.setState({ isDropHidden: true });
      }
      this.fetchParentData();
      this.fetchAllStudents();
    }

    if (userType === "student") {


      if (flg_list_active === null) {

        StudentService.getCreateUserDetail(
          lg_user_id,
          lg_user_table_id,
          userType
        ).then((response) => {
          const create_user_id = response.data.user_detail[0].create_user_id;
          const create_user_table_id = response.data.user_detail[0].create_user_table_id;


          this.setState({
            create_user_id: create_user_id,
            create_user_table_id: create_user_table_id,
            isDropHidden: false,
          }, () => {
            this.fetchStudentData();
            this.fetchAllEnrolledChildPapers();
          });
        });
      }

    }

    if (userType === "parent") {
      // if (flg_list_active === 1) {
      //   this.setState({ isDropHidden: true });
      // }
      this.setState({ isDropHidden: true });
      this.fetchParentData();
      this.fetchAllStudents();
    }
    this.fetchAllAssessmentSettings();


    // window.addEventListener('paymentAccepted', this.handleEnrollment);
    // if (sessionStorage.getItem('payment_terms_accepted') === 'true') {
    //   sessionStorage.removeItem('payment_terms_accepted');
    //   this.handleEnrollment();
    // }
  }

  //   componentWillUnmount() {
  //     window.removeEventListener('paymentAccepted', this.handleEnrollment);
  // }

  getVisibilityCheck(
    privilage_view,
    privilege_add,
    privilege_delete,
    privilege_edit
  ) {
    if (privilege_add === 1) {
      this.setState({
        addVisibility: true,
      });
    } else if (privilege_edit === 1) {
      this.setState({
        editVisibility: true,
      });
    } else if (privilage_view === 1) {
      this.setState({
        viewVisibility: true,
      });
    } else if (privilege_delete === 1) {
      this.setState({
        deleteVisibility: true,
      });
    }
  }

  fetchStudentGrade = async () => {
    this.setState({ isTableDataLoading: true });
    let email = sessionStorage.getItem("email");
    await StudentService.getStudentbyEmail(email).then((response) => {
      sessionStorage.setItem("studentGrade", response.data.grade);
    })
  }

  fetchSelectedStudentGrade = async () => {
    this.setState({ isTableDataLoading: true });
    const { selectedStudent } = this.state;
    await StudentService.getById(parseInt(selectedStudent)).then((response) => {
      sessionStorage.setItem("selectedStudentGrade", response.data.grade);
    })
  }

  fetchStudentData = async () => {
    await this.fetchStudentGrade();
    await this.fetchAllPapersForStudent();
  }

  fetchParentData = async () => {
    await this.fetchAllPapersForParent();
  }

  fetchAllAssessmentSettings() {
    this.setState({
      isTableDataLoading: true
    });

    const fetchAssessmentMetaData = assessmentService.getAllAssessmentMetaData();
    Promise.all([
      fetchAssessmentMetaData
    ])
      .then((response) => {
        const [
          assessmentMetaDataResponse
        ] = response;

        this.setState({
          allCategories: assessmentMetaDataResponse.data.find(item => 'categories' in item).categories,
          allLanguages: assessmentMetaDataResponse.data.find(item => 'languages' in item).languages,
          allSubjects: assessmentMetaDataResponse.data.find(item => 'subjects' in item).subjects,
          allAuthors: assessmentMetaDataResponse.data.find(item => 'authors' in item).authors,
          allYears: assessmentMetaDataResponse.data.find(item => 'years' in item).years,
          allDifficulties: assessmentMetaDataResponse.data.find(item => 'difficulty_types' in item).difficulty_types,
          allGrades: assessmentMetaDataResponse.data.find(item => 'grades' in item).grades,
          allTerms: assessmentMetaDataResponse.data.find(item => 'terms' in item).terms,
          allChapters: assessmentMetaDataResponse.data.find(item => 'chapters' in item).chapters,
          allCurrencyTypes: assessmentMetaDataResponse.data.find(item => 'currency_types' in item).currency_types,
          allUnits: assessmentMetaDataResponse.data.find(item => 'units' in item).units,
          isLoading: false
        }, async () => {

          const studentGrade = parseInt(sessionStorage.getItem("studentGrade"), 10);
          const studentLanguage = parseInt(sessionStorage.getItem("studentMedium"), 10);

          if (this.state.allGrades && this.state.allGrades.length > 0) {

            const matchingGrade = this.state.allGrades.find((grade) => grade.grade_id === studentGrade);

            if (matchingGrade) {
              matchingGrade.filter = "Grade";
              matchingGrade.name = matchingGrade.grade
              await this.onSelectFilterMulti(matchingGrade)
            }

          }

          if (this.state.allLanguages && this.state.allLanguages.length > 0) {

            const matchingLanguage = this.state.allLanguages.find((language) => language.language_id === studentLanguage);



            if (matchingLanguage) {
              matchingLanguage.filter = "Language";
              matchingLanguage.name = matchingLanguage.language

              this.onSelectFilterMulti(matchingLanguage)
            }

          }

        });

      })
      .catch((error) => {
        this.setState({
          isTableDataLoading: false,
        });
      });
  }

  getCurrencyTypeSymbol(currency_type_id) {
    if (currency_type_id !== null) {
      const currency_type = this.state.allCurrencyTypes?.find(
        (currency_type) => currency_type.currency_type_id == parseInt(currency_type_id)
      );
      return currency_type?.symbol;
    }
    else {
      return "N/A";
    }
  }

  getCurrencyTypeName(currency_type_id) {
    if (currency_type_id !== null) {
      const currency_type = this.state.allCurrencyTypes?.find(
        (currency_type) => currency_type.currency_type_id == parseInt(currency_type_id)
      );
      return currency_type?.name;
    }
    else {
      return "N/A";
    }
  }

  getAllGrades = async () => {
    this.setState({ isGradeLoading: true });
    await GradeService.getGrades()
      .then((response) => {
        if (response.success) {
          this.setState({ grades: response.data, isGradeLoading: false })
        }
        else {
          this.setState({ isGradeLoading: false });
        }

      })
  }

  findGrade = (grade_id) => {
    const { grades } = this.state
    if (grades && grades.length > 0) {

      const paperGrade = grades.find((grade) => grade.grade_id === parseInt(grade_id));

      return paperGrade ? String(paperGrade.grade) : "N/A"
    }
    else {
      return "N/A"
    }
  }

  getAllSubjects = async () => {
    this.setState({ isSubjectLoading: true });
    await assessSubjectService.getAllSubjects()
      .then((response) => {
        if (response.success) {
          this.setState({ subjects: response.data.subjects, isSubjectLoading: false })
        }
        else {
          this.setState({ isSubjectLoading: false });
        }

      })
  }

  findSubject = (subject_id) => {
    const { subjects } = this.state
    if (subjects && subjects.length > 0) {

      const paperSubject = subjects.find((subject) => subject.subject_id === parseInt(subject_id));

      return paperSubject ? String(paperSubject.subject) : "N/A"
    }
    else {
      return "N/A"
    }
  }

  getAllYears = async () => {
    this.setState({ isYearLoading: true });
    await assessYearService.getAllYears()
      .then((response) => {
        if (response.success) {
          this.setState({ years: response.data.years, isYearLoading: false })
        }
        else {
          this.setState({ isYearLoading: false });
        }

      })
  }

  findYear = (year_id) => {
    const { years } = this.state
    if (years && years.length > 0) {

      const paperYear = years.find((year) => year.year_id === parseInt(year_id));

      return paperYear ? String(paperYear.year) : "N/A"
    }
    else {
      return "N/A"
    }
  }

  getPaperCategory(category_id) {
    if (category_id !== null) {
      const category = this.state.allCategories?.find(
        (category) => category.category_id == category_id
      );
      return category?.name;
    }
    else {
      return "N/A";
    }
  }

  getPaperLanguage(language_id) {
    if (language_id !== null) {
      const language = this.state.allLanguages?.find(
        (language) => language.language_id == language_id
      );
      return language?.language;
    }
    else {
      return "N/A";
    }
  }

  getPaperSubject(subject_id) {
    if (subject_id !== null) {
      const subject = this.state.allSubjects?.find(
        (subject) => subject.subject_id == subject_id
      );
      return subject?.subject;
    }
    else {
      return "N/A";
    }
  }

  getPaperAuthor(author_id) {
    if (author_id !== null) {
      const author = this.state.allAuthors?.find(
        (author) => author.author_id == author_id
      );
      return author?.author;
    }
    else {
      return "N/A";
    }
  }

  getPaperYear(year_id) {
    if (year_id !== null) {
      const year = this.state.allYears?.find(
        (year) => year.year_id == year_id
      );
      return year?.year;
    }
    else {
      return "N/A";
    }
  }

  getPaperDifficulty(difficulty_id) {
    if (difficulty_id !== null) {
      const difficulty = this.state.allDifficulties?.find(
        (difficulty) => difficulty.difficulty_id == difficulty_id
      );
      return difficulty?.difficulty_type;
    }
    else {
      return "N/A";
    }
  }

  getPaperGrade(grade_id) {
    if (grade_id !== null) {
      const grade = this.state.allGrades?.find(
        (grade) => grade.grade_id == grade_id
      );
      return grade?.grade;
    }
    else {
      return "N/A";
    }
  }

  getPaperTerm(term_id) {
    if (term_id !== null) {
      const term = this.state.allTerms?.find(
        (term) => term.term_id == term_id
      );
      return term?.term;
    }
    else {
      return "N/A";
    }
  }

  getPaperChapter(chapter_id) {
    if (chapter_id !== null) {
      const chapter = this.state.allChapters?.find(
        (chapter) => chapter.chapter_id == chapter_id
      );
      return chapter?.chapter;
    }
    else {
      return "N/A";
    }
  }

  getCreatedAtLocal(time) {
    if (time != null) {
      let timeStamp = new Date(time.concat("Z"))
      let d = new Date(timeStamp)
      // let startDate = d.toDateString();
      // let startTime = d.toLocaleTimeString('en-SL');
      let local = moment(timeStamp).local().format("MMMM Do YYYY hh:mm A")
      return local;
    }
    else {
      return "N/A";
    }
  }

  callAfterSubmit() {
    this.setState({ isTableDataLoading: true });
    let userType = sessionStorage.getItem("userType");
    if (userType === "student") {
      this.fetchStudentData();
      // this.fetchEnrollPaperData();
    }
    else {
      this.fetchParentData();
      this.fetchEnrollPaperData();
    }
  }

  fetchAllPapersForStudent = async () => {
    this.setState({ isTableDataLoading: true });
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedDifficulties,
      selectedGrades,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
    } = this.state;

    let node_mid = this.props.state.mid;

    if (selectedGrades !== null) {
      await PaperService.getfilterdAllAssesmentsMultiFilter(
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTerms,
        selectedYears,
        selectedsubjects
      )
        .then((response) => {
          if (response.success) {
            this.setState({
              papers: response.data.papers,
              totalPapers: response.data.count,
              isTableDataLoading: false,
            });
          } else {
            sweetStatusAlert(
              "Failed!",
              "Error fetching papers. Please refresh the screen!",
              "Error"
            );
          }
        })
        .catch((error) => {
          sweetStatusAlert(
            "Failed!",
            "Error fetching papers. Please refresh the screen!",
            "Eerror"
          );
        })
        .finally(() => {
          this.setState({ isTableDataLoading: false });
        });
    }
    else {
      await PaperService.getfilterdAllAssesmentsMultiFilter(
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        // sessionStorage.getItem("studentGrade"),
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTerms,
        selectedYears,
        selectedsubjects
      )
        .then((response) => {
          if (response.success) {
            this.setState({
              papers: response.data.papers,
              totalPapers: response.data.count,
              isTableDataLoading: false,
            });
          } else {
            sweetStatusAlert(
              "Failed!",
              "Error fetching papers. Please refresh the screen!",
              "Error"
            );
          }
        })
        .catch((error) => {
          sweetStatusAlert(
            "Failed!",
            "Error fetching papers. Please refresh the screen!",
            "Eerror"
          );
        })
        .finally(() => {
          this.setState({ isTableDataLoading: false });
        });
    }

  };

  fetchAllPapersForParent = async () => {
    const {
      limit,
      offset,
      sortColumn,
      sortDirection,
      search_term,
      selectedCategories,
      selectedAuthors,
      selectedChapters,
      selectedDifficulties,
      selectedGrades,
      selectedLanguages,
      selectedTerms,
      selectedYears,
      selectedsubjects,
    } = this.state;


    if (selectedGrades !== null) {
      await PaperService.getfilterdAllAssesmentsParent(
        limit,
        offset,
        sortColumn,
        sortDirection,
        search_term,
        selectedCategories,
        selectedAuthors,
        selectedChapters,
        selectedGrades,
        selectedDifficulties,
        selectedLanguages,
        selectedTerms,
        selectedYears,
        selectedsubjects
      )
        .then((response) => {
          if (response.success) {
            this.setState({
              papers: response.data.papers,
              totalPapers: response.data.count,
              isTableDataLoading: false,
            });
          } else {
            sweetStatusAlert(
              "Failed!",
              "Error fetching papers. Please refresh the screen!",
              "Error"
            );
          }
        })
        .catch((error) => {
          sweetStatusAlert(
            "Failed!",
            "Error fetching papers. Please refresh the screen!",
            "Eerror"
          );
        })
        .finally(() => {
          this.setState({ isTableDataLoading: false });
        });
    }

  };

  // Add this method to the class
  toggleFilterCollapse = () => {
    this.setState(prevState => ({
      isFilterCollapsed: !prevState.isFilterCollapsed
    }));
  };

  handleViewClick = (e, paper) => {
    e.preventDefault();
    this.setState({
      selectedPaper: paper,
      showDetailModal: true,
    });
  };

  toggleDetailModal = () => {
    this.setState((prevState) => ({
      showDetailModal: !prevState.showDetailModal,
    }));
  };

  handlePageChange = (event, newPage) => {
    const { limit } = this.state;
    const newOffset = newPage * limit;
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handlePageOffsetChange = (newOffset, newPage) => {
    this.setState(
      {
        offset: newOffset,
        isTableDataLoading: true,
        currentPage: newPage
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handleRowsPerPageChange = (event) => {
    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(this.state.offset / newLimit);
    this.setState(
      {
        limit: newLimit,
        offset: newLimit * newPage,
        isTableDataLoading: true,
        currentPage: newPage,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  handleSearch = (event) => {
    const search_term = event.target.value.trim();
    const regex = /^[a-zA-Z0-9][a-zA-Z0-9@\s.&]*$/;

    if (search_term === "" || regex.test(search_term)) {
      this.setState(
        {
          search_term,
          isTableDataLoading: true,
          offset: 0,
          currentPage: 0,
          searchError: false,
        },
        () => {
          this.debouncedHandleSearch();
        }
      );
    } else {
      this.setState({ search_term, searchError: true });
    }
  };

  handleSortChange = (sortColumn) => {
    const { sortColumn: currentSortColumn, sortDirection } = this.state;
    const newSortDirection =
      currentSortColumn === sortColumn && sortDirection === "asc"
        ? "desc"
        : "asc";

    this.setState(
      {
        sortColumn,
        sortDirection: newSortDirection,
        offset: 0, // Reset offset when changing sorting
        currentPage: 0,
        isTableDataLoading: true,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  fetchAllStudents = async () => {
    const { lg_user_id, lg_user_table_id } = this.props.state;

    this.setState({ isTableDataLoading: true });

    let userType = sessionStorage.getItem("userType");
    let user_id;
    let user_table_id;

    if (userType === "parent") {
      user_id = sessionStorage.getItem("parent_group_id");
      user_table_id = sessionStorage.getItem("parent_group_user_table_id");
    } else {
      user_id = lg_user_id;
      user_table_id = lg_user_table_id;
    }

    await StudentService.getAllEdStudentsForParent(
      user_id,
      user_table_id,
      userType
    )
      .then((response) => {
        if (response.success) {
          this.setState({ studentlist: response.data.students });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching students. Please refresh the screen!",
            "error"
          );
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Failed!",
          "Error fetching students. Please refresh the screen!",
          "error"
        );
      })
      .finally(() => {
        this.setState({ isTableDataLoading: false });
      });
  };

  toggleEnrollModal = (asses_id, assess_name) => {
    const { userType } = this.state;
    const session_id = sessionStorage.getItem("manage_user_id");
    const handleEnrollment = () => {
      this.setState({ isSpinnerLoading: true }, () => {
        if (userType === "student") {
          StudentService.getreference(session_id).then((response) => {
            if (
              response.data.reference_id &&
              response.data.has_parent
            ) {
              this.handleSubmit(asses_id, assess_name);
            } else {
              this.handleSubmitStudent(asses_id, assess_name);
            }
          });
        } else {
          this.handleSubmit(asses_id, assess_name);
        }
      });
    };

    var confirmMessage = "";

    if (userType === "student") {
      confirmMessage = "Are you sure you want to enroll for this exam?";
    }
    else if (userType === "parent") {
      confirmMessage = "Do you want to enroll this exam for your child?";
    }
    else {
      confirmMessage = "Do you want to enroll this exam for the selected student?";
    }

    sweetAlertEnroll("Enroll Confirmation", confirmMessage).then((enrollConfirmed) => {
      if (enrollConfirmed) {
        this.setState({ showInsertModal: false });
        handleEnrollment();
      }
    });

  };

  toggleExamEnrollModal = (asses_id, assess_name, assess_credits) => {
    const { userType } = this.state;
    const session_id = sessionStorage.getItem("manage_user_id");
    const handleEnrollment = () => {
      this.setState({ isSpinnerLoading: true }, () => {
        this.handleExamSubmit(asses_id, assess_name, assess_credits);
      });
    };

    var confirmMessage = "";

    if (userType === "student") {
      confirmMessage = "Are you sure you want to enroll for this exam?";
    }
    else if (userType === "parent") {
      confirmMessage = "Do you want to enroll this exam for your child?";
    }
    else {
      confirmMessage = "Do you want to enroll this exam for the selected student?";
    }

    sweetAlertEnroll("Enroll Confirmation", confirmMessage).then((enrollConfirmed) => {
      if (enrollConfirmed) {
        this.setState({ showCreditInsertModal: false });
        handleEnrollment();
      }
    });
  };

  getUnit(unit_id) {
    let unit = this.state.allUnits.find(unit => unit.unit_id === parseInt(unit_id, 10))?.unit
    return unit;
  }

  convertTestDurationInSelectedUnit = (value) => {
    if (typeof value !== 'number' || isNaN(value) || value < 0) return 'Unlimited';
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    let result = '';
    if (hours > 0) result += `${hours} hour${hours > 1 ? 's' : ''}`;
    if (minutes > 0) result += `${hours > 0 ? ' ' : ''}${minutes} minute${minutes > 1 ? 's' : ''}`;
    return result || '0 minutes';
  }

  toggleAssessmentCreditEnrollModal = (asses_id, no_of_credits, amount, currencySymbol, currencyId, currencyName) => {
    const { userType } = this.state;

    var confirmMessage = "";

    if (userType === "student") {
      confirmMessage = "Are you sure you want to proceed with purchasing and enrolling for this exam? Once you accept the Privacy Policy and Terms & Conditions, a secure third-party payment page will open to process your payment.";

    }
    else if (userType === "parent") {
      confirmMessage = "Do you want to buy and enroll this exam for your child? A secure third-party payment page will open to handle your transaction safely.";
    }
    else {
      confirmMessage = "Do you want to buy and enroll this exam for the selected student? A secure third-party payment page will open to handle your transaction safely.";
    }
    // Build a richer pending payload and persist it to sessionStorage and localStorage
    const pending = {
      asses_id,
      no_of_credits,
      amount,
      currencySymbol,
      currencyId,
      currencyName,
      userType,
      assess_name: this.state.assess_name || null,
      selectedStudent: this.state.selectedStudent || null,
      create_user_id: this.state.create_user_id || null,
      create_user_table_id: this.state.create_user_table_id || null,
    };

    // Use both storages so the data survives route transitions/unmounts
    sessionStorage.setItem('pendingAssessmentCreditEnrollment', JSON.stringify(pending));


    sweetAlertEnroll("Enroll Confirmation", confirmMessage).then((enrollConfirmed) => {
      if (enrollConfirmed) {
        // pass pending via route state as a final fallback
        history.push({ pathname: routes.payment_terms_condition, state: { pendingAssessmentCreditEnrollment: pending } });
        this.setState({ showInsertModal: false, showCreditInsertModal: false });
      }
    });

  };

  handleEnrollment = () => {
    const session_id = sessionStorage.getItem("manage_user_id");

    // Read pending from sessionStorage, fallback to localStorage or history.state
    let pending = {};
    try {
      pending = JSON.parse(sessionStorage.getItem('pendingAssessmentCreditEnrollment') || '{}');
    } catch (e) {
      pending = {};
    }

    // Try route state as a last resort (history was used when navigating)
    if (!pending || Object.keys(pending).length === 0) {
      const historyPending = history && history.location && history.location.state && history.location.state.pendingAssessmentCreditEnrollment;
      if (historyPending) pending = historyPending;
    }

    // Validate pending
    if (!pending || !pending.asses_id) {
      sweetStatusAlert("Error!", "No pending payment/enrollment found. Please try again.", "error");
      this.setState({ isSpinnerLoading: false });
      return;
    }

    let enrollType = "user";
    this.setState({ isSpinnerLoading: true }, () => {
      // Decide enrollType for student
      if (pending.userType === "student") {
        StudentService.getreference(session_id).then((response) => {
          if (!(response.data.reference_id && response.data.has_parent)) {
            enrollType = "student";
          }
          // Pass the full pending object as last arg so the submit handler can recover missing state if component was unmounted
          this.handleAssessmentCreditSubmit(pending.asses_id, pending.no_of_credits, pending.amount, enrollType, pending.currencySymbol, pending.currencyId, pending.currencyName, pending);
        }).catch(() => {
          // still attempt with pending
          this.handleAssessmentCreditSubmit(pending.asses_id, pending.no_of_credits, pending.amount, enrollType, pending.currencySymbol, pending.currencyId, pending.currencyName, pending);
        });
      } else {
        this.handleAssessmentCreditSubmit(pending.asses_id, pending.no_of_credits, pending.amount, enrollType, pending.currencySymbol, pending.currencyId, pending.currencyName, pending);
      }
    });
  };

  handleSubmitStudent = async (assessment_id, assess_name) => {
    const { selectedStudent, userType, selectedCredit } = this.state;

    const UserId = sessionStorage.getItem("manage_user_id");

    var enrolledby = "";
    var credit_id = "";

    const attempt_no = this.state.papers.find(
      (assessment) => assessment.assessment_id === assessment_id
    );

    if (userType === "student") {
      enrolledby = "Student";
    } else if (userType === "admin") {
      enrolledby = "Admin";
    } else {
      enrolledby = "Parent";
    }

    let student = this.state.studentlist.find(
      (student) => student.stu_id === parseInt(selectedStudent.stu_id)
    );

    if (selectedCredit) {
      credit_id = selectedCredit.credit_id;
    }

    const enrolled_paper = {
      node_mid: !!this.props.state.mid ? this.props.state.mid : null,
      create_user_id:
        userType === "admin" || userType === "student"
          ? this.state.create_user_id
          : this.props.state.lg_user_id,
      create_user_table_id:
        userType === "parent"
          ? this.props.state.lg_user_table_id
          : this.state.create_user_table_id,
      enroll_user_id:
        userType === "student" ? UserId : parseInt(selectedStudent.stu_id),
      assessment_id: assessment_id,
      assess_name: assess_name,
      paper_status: 0,
      enrolled_by: enrolledby,
      enroll_user_table_id: userType === "student" ? 2 : student.user_table_id,
      user_table_id: userType === "student" ? 2 : student.user_table_id,
      attempt_no: attempt_no.attempt_no,
      userType: userType,
      credit_id: credit_id,
    };

    EnrolledPaperService.selfenrollPaperToNode(JSON.stringify(enrolled_paper))
      .then((response) => {
        if (response.success) {
          sweetStatusAlert(
            "Success!",
            "You have successfully enrolled to exam " +
            enrolled_paper.assess_name +
            "!",
            "success"
          );

          this.callAfterSubmit();
          this.setState({
            isSpinnerLoading: false,
            selectedCredit: null,
            isCreditNotAvailable: false,
            isModified: false,
            asses_id: null,
            assess_name: null,
            showInsertModal: false,
            showCreditInsertModal: false,
            showCreditBuyModal: false
          });
        } else {
          sweetStatusAlert(
            "Error!",
            "Failed to enroll. You may not have enough credits. Please check your available credits!.",
            "error"
          );
          this.setState({ isSpinnerLoading: false });
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Error!",
          "An error occurred while enrolling the student. Please try again later.",
          "error"
        );
        this.setState({ isSpinnerLoading: false });
      });
  };

  handleStudentSelect = async (event) => {
    if (!event.target.value) {
      this.setState({ selectedStudent: "" });
      return;
    }
    let student = this.state.studentlist.find(
      (student) => student.user_id === parseInt(event.target.value) ||
        student.stu_id === parseInt(event.target.value));

    this.setState({ isTableDataLoading: true });

    const selectedStudent = student

    if (selectedStudent) {

      await this.clearAllFilters()

      let create_user_id = student.create_user_id
      let create_user_table_id = student.create_user_table_id

      this.setState({
        create_user_id: create_user_id,
        create_user_table_id: create_user_table_id,
      });

      const { grades } = this.state

      let stu_grade

      if (grades && grades.length > 0) {
        stu_grade = grades.find((grade) => grade.grade_id === parseInt(student.grade));
      }

      sessionStorage.setItem("selectedStudentGrade", parseInt(stu_grade));

      let selectedGrades = [];
      selectedGrades.push(stu_grade)

      if (stu_grade) {
        stu_grade.filter = "Grade";
        stu_grade.name = stu_grade.grade
        this.onSelectFilterMulti(stu_grade)
      }

      this.setState({ selectedStudent }, async () => {
        // await this.fetchSelectedStudentGrade();
        await this.fetchEnrollPaperData();
        await this.fetchAllPapersForParent();

      });
    }
  };

  handleSubmit = async (assessment_id, assess_name) => {
    const { selectedStudent, userType, selectedCredit } = this.state;
    const UserId = sessionStorage.getItem("manage_user_id");
    var enrolledby = "";
    var sentTo = "";
    var msg = "";
    var credit_id = "";

    const attempt_no = this.state.papers.find(
      (assessment) => assessment.assessment_id === assessment_id
    );

    if (userType === "student") {
      enrolledby = "Student";
    } else if (userType === "admin") {
      enrolledby = "Admin";
    } else {
      enrolledby = "Parent";
    }

    if (userType === "student") {
      sentTo = "your parent";
      msg = "Please wait until your parent approves";
    } else if (userType === "admin") {
      sentTo = "Parent";
      msg = "Please wait until the parent of the selected student approves";
    } else {
      sentTo = "you";
      msg = "Please check your mail inbox or spam/junk";
    }

    let student = this.state.studentlist.find(
      (student) => student.stu_id === parseInt(selectedStudent.stu_id)
    );
    if (selectedCredit) {
      credit_id = selectedCredit.credit_id;
    }

    const enrolled_paper = {
      node_mid: !!this.props.state.mid ? this.props.state.mid : null,
      create_user_id:
        userType === "admin" || userType === "student"
          ? this.state.create_user_id
          : sessionStorage.getItem("parent_group_id"),
      create_user_table_id:
        userType === "parent"
          ? sessionStorage.getItem("parent_group_user_table_id")
          : this.state.create_user_table_id,
      enroll_user_id:
        userType === "student" ? UserId : parseInt(selectedStudent.stu_id),
      assessment_id: assessment_id,
      assess_name: assess_name,
      paper_status: 0,
      enrolled_by: enrolledby,
      enroll_user_table_id: userType === "student" ? 2 : student.user_table_id,
      user_table_id: userType === "student" ? 2 : student.user_table_id,
      attempt_no: attempt_no.attempt_no,
      userType: userType,
      credit_id: credit_id,
    };

    EnrolledPaperService.addEnrolledPaperToNode(JSON.stringify(enrolled_paper))
      .then((response) => {
        if (response.success) {
          let parentEmail = response?.data?.credit_owner_parent_email
          if (userType === "student") {
            sweetStatusAlert(
              "Success!",
              "You have enrolled to the exam successfully!",
              "success"
            );
          }
          else {
            sweetStatusAlert(
              "Success!",
              "Student has been enrolled to the exam successfully!",
              "success"
            );
          }
          this.fetchEnrollPaperData();
          this.callAfterSubmit();
          this.setState({
            isSpinnerLoading: false,
            selectedCredit: null,
            isCreditNotAvailable: false,
            isModified: false,
            asses_id: null,
            assess_name: null,
            showInsertModal: false,
            showCreditBuyModal: false,
          });
        } else {
          sweetStatusAlert(
            "Error!",
            "Failed to enroll. Please try again later.",
            "error"
          );
          this.setState({ isSpinnerLoading: false });
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Error!",
          "An error occurred while enrolling the student. Please try again later.",
          "error"
        );
        this.setState({ isSpinnerLoading: false });
      });
  };

  handleToggleCredit = (event, credit) => {
    const { selectedCredits, assess_credits } = this.state;
    let updatedCredits;

    if (event.target.checked) {
      updatedCredits = [...selectedCredits, credit];
    } else {
      updatedCredits = selectedCredits.filter(c => c.exam_credit_id !== credit.exam_credit_id);
    }

    const totalSelectedCredits = updatedCredits.reduce((sum, c) => sum + c.available_credits, 0);

    this.setState({
      selectedCredits: updatedCredits,
      totalSelectedCredits,
      isCreditSufficient: totalSelectedCredits >= assess_credits
    });
  };

  handleExamSubmit = async (assessment_id, assess_name, assess_credits) => {
    const { selectedStudent, userType, selectedCredit } = this.state;
    const UserId = sessionStorage.getItem("manage_user_id");
    var enrolledby = "";

    var credit_id = "";
    var credit_amount = "";

    const attempt_no = this.state.papers.find(
      (assessment) => assessment.assessment_id === assessment_id
    );

    if (userType === "student") {
      enrolledby = "Student";
    } else if (userType === "admin") {
      enrolledby = "Admin";
    } else {
      enrolledby = "Parent";
    }

    let student = this.state.studentlist.find(
      (student) => student.stu_id === parseInt(selectedStudent.stu_id)
    );
    if (selectedCredit) {
      credit_id = selectedCredit.credit_id;
      credit_amount = assess_credits;
    }
    const creditUsagePayload = this.state.selectedCredits.map(c => ({
      id: c.exam_credit_id,
      available_credits: c.available_credits
    }));


    const enrolled_paper = {
      node_mid: !!this.props.state.mid ? this.props.state.mid : null,
      create_user_id:
        userType === "admin" || userType === "student"
          ? this.state.create_user_id
          : sessionStorage.getItem("parent_group_id"),
      create_user_table_id:
        userType === "parent"
          ? sessionStorage.getItem("parent_group_user_table_id")
          : this.state.create_user_table_id,
      enroll_user_id:
        userType === "student" ? UserId : parseInt(selectedStudent.stu_id),
      assessment_id: assessment_id,
      assess_name: assess_name,
      credits: creditUsagePayload,
      assessment_credits: assess_credits,
      paper_status: 0,
      enrolled_by: enrolledby,
      enroll_user_table_id: userType === "student" ? 2 : student.user_table_id,
      user_table_id: userType === "student" ? 2 : student.user_table_id,
      attempt_no: attempt_no.attempt_no,
      userType: userType,
    };
    EnrolledPaperService.addEnrolledExamToNode(JSON.stringify(enrolled_paper))
      .then((response) => {
        if (response.success) {
          this.props.handleChange(null, 1, {
            value: 1,
            candidateStatus: "Assigned",
            paperStatus: "Not Started",
            candidateId: userType === "student" ? parseInt(UserId) : parseInt(selectedStudent.stu_id)
          });
          sweetStatusAlert(
            "Success!",
            "You have enrolled to the exam successfully!",
            "success"
          );
          // else {
          //   sweetStatusAlert(
          //     "Success!",
          //     "Student has been enrolled to the exam successfully!",
          //     "success"
          //   );
          // }
          this.fetchEnrollPaperData();
          this.callAfterSubmit();
          this.setState({
            isSpinnerLoading: false,
            selectedCredit: null,
            isCreditNotAvailable: false,
            isModified: false,
            asses_id: null,
            assess_credits: null,
            assess_name: null,
            showInsertModal: false,
            showCreditInsertModal: false,
            showCreditBuyModal: false,
            selectedCredits: [],
            totalSelectedCredits: 0,
            isCreditSufficient: false,
            isCreditNotAvailable: false,
            totalSelectedCredits: 0,
          });
        } else {
          sweetStatusAlert(
            "Error!",
            "Failed to enroll. Please try again later.",
            "error"
          );
          this.setState({ isSpinnerLoading: false });
        }
      })
      .catch((error) => {
        sweetStatusAlert(
          "Error!",
          "An error occurred while enrolling the student. Please try again later.",
          "error"
        );
        this.setState({ isSpinnerLoading: false });
      });
  };


  handleAssessmentCreditSubmit = async (assessment_id, no_of_credits, amount, enrollType, currencySymbol, currencyId, currencyName, pending = {}) => {
    const mid = 100;
    const session_id = sessionStorage.getItem("manage_user_id");
    const UserId = sessionStorage.getItem("manage_user_id");
    const table_log_id = sessionStorage.getItem("table_log_id");

    // Use pending fields as fallback in case component state was lost during navigation
    const userType = pending.userType || this.state.userType;
    const assess_name = pending.assess_name || this.state.assess_name;
    const selectedStudent = pending.selectedStudent || this.state.selectedStudent;
    const create_user_id_fallback = pending.create_user_id || this.state.create_user_id;
    const create_user_table_id_fallback = pending.create_user_table_id || this.state.create_user_table_id;

    // Resolve student object (either object passed in pending or find in list)
    let student = null;
    if (selectedStudent) {
      if (typeof selectedStudent === 'object') {
        student = selectedStudent;
      } else {
        student = this.state.studentlist && this.state.studentlist.find(
          (s) => s.stu_id === parseInt(selectedStudent) || s.user_id === parseInt(selectedStudent)
        );
      }
    }

    let paid_by = sessionStorage.getItem("username");
    const attempt_no = this.state.papers && this.state.papers.find(
      (assessment) => assessment.assessment_id === assessment_id
    ) || { attempt_no: 1 };

    var enrolledby = "";
    if (userType === "student") {
      enrolledby = "Student";
    } else if (userType === "admin") {
      enrolledby = "Admin";
    } else {
      enrolledby = "Parent";
    }

    var enrollment_create_user_id = "";
    var enrollment_create_user_table_id = "";
    if (enrollType === "student") {
      enrollment_create_user_id = (userType === "admin" || userType === "student"
        ? create_user_id_fallback
        : this.props.state.lg_user_id);
      enrollment_create_user_table_id = (userType === "parent"
        ? this.props.state.lg_user_table_id
        : create_user_table_id_fallback);
    } else {
      enrollment_create_user_id = (userType === "admin" || userType === "student"
        ? create_user_id_fallback
        : sessionStorage.getItem("parent_group_id"));
      enrollment_create_user_table_id = (userType === "parent"
        ? sessionStorage.getItem("parent_group_user_table_id")
        : create_user_table_id_fallback);
    }

    // If student info is missing for parent flow, abort with a helpful error
    if (!student && userType !== 'student') {
      sweetStatusAlert("Error!", "Student information is missing. Please re-start the enrollment and select a student.", "error");
      this.setState({ isSpinnerLoading: false });
      return;
    }

    const payment_obj = {
      email: sessionStorage.getItem("email"),
      unit_amount: parseFloat(amount).toFixed(2),
      amount: parseFloat(amount).toFixed(2),
      credits: parseInt(no_of_credits),
      currency_type: this.getCurrencyTypeSymbol(currencyId),
      assessment_name: assess_name,
      node_mid: mid,
      assessment_id: assessment_id,
      // node_mid: !!this.props.state.mid ? this.props.state.mid : null,
      enrollment_create_user_id: enrollment_create_user_id,
      enrollment_create_user_table_id: enrollment_create_user_table_id,
      user_id: userType === "student" ? session_id : (student && (student.user_id || student.stu_id)),
      user_table_id: userType === "student" ? table_log_id : (student && student.user_table_id),
      create_user_id: session_id,
      create_user_table_id: table_log_id,
      paid_by: paid_by,
      payment_method: "Online",
      reference_id: "N/A",
      form_list_id: 46,
      userType: userType,
      attempt_no: attempt_no.attempt_no,
      paper_status: 0,
      enrolled_by: enrolledby,
      enroll_user_table_id: userType === "student" ? 2 : (student && student.user_table_id),
      enroll_user_id: userType === "student" ? UserId : (student && (student.user_id || student.stu_id)),
      enrollType: enrollType,
      currencySymbol: currencySymbol,
      currencyId: currencyId,
      currencyName: currencyName
    };

    try {
      // Add popstate listener to handle browser back navigation
      window.addEventListener('popstate', this.handlePaymentCancelNavigation);

      // Initiate session and then remove pending saved data so it's not stale
      const res = await CombankService.getSessionIDAssessmentPurchase(JSON.stringify(payment_obj));
      sessionStorage.setItem("checkout_session_id", res.data.session.id);

      // Remove pending (we have initiated the payment flow)
      try { sessionStorage.removeItem('pendingAssessmentCreditEnrollment'); } catch (e) { /* ignore */ }

      this.setState({ is_submit_credit: false }, () => {
        this.loadCheckoutScript(res.data.session.id);
      });
    } catch (error) {
      sweetStatusAlert("Error!", "An error occurred while getting session ID.", "error");
      this.setState({ is_submit_credit: false })
    }
  };

  handlePaymentCancelNavigation = () => {
    // Clear any pending enrollment data if user navigates back/cancels
    try { sessionStorage.removeItem('pendingAssessmentCreditEnrollment'); } catch (e) { /* ignore */ }

    this.cancelCallback();
    window.removeEventListener('popstate', this.handlePaymentCancelNavigation);
  };

  loadCheckoutScript = (sessionID) => {
    const script = document.createElement("script");
    script.src = "https://cbcmpgs.gateway.mastercard.com/static/checkout/checkout.min.js";
    document.head.appendChild(script);
    script.onload = () => {
      window.Checkout.configure({
        session: {
          id: sessionID,
        },
      });

      window.Checkout.onComplete = this.successCallback;
      window.Checkout.onError = this.errorCallback;
      window.Checkout.onCancel = this.cancelCallback;

      if (window.Checkout) {
        if (this.props.customer !== customerConstants.EXO_CUSTOMER2) {
          const script = document.querySelector("script[src*='checkout.min.js']");
          if (script) {
            document.head.removeChild(script);
          }
        }
        window.Checkout.showPaymentPage();
      }
    };
  };

  fetchEnrollPaperData = async () => {

    this.setState({ isTableDataLoading: true });

    const { selectedStudent, create_user_id, create_user_table_id } = this.state;

    const {
      lg_user_id,
      lg_user_table_id,
      user_list_table_id,
      user_list_restriction,
    } = this.props.state;


    if (this.state.userType === "student") {

      await EnrolledPaperService.getAllEnrolledPapersMultiFilter(
        create_user_id,
        create_user_table_id,
        lg_user_id,
        lg_user_table_id,
        this.state.userType
      )
        .then((res) => {
          this.setState({ enrolledPapers: res.data.enrolledPapers });
        })
        .finally(() => {
          this.setState({ isTableDataLoading: false });
        });
    }
    else if (this.state.userType === "parent" && selectedStudent) {

      await EnrolledPaperService.getAllEnrolledPapersMultiFilter(
        create_user_id,
        create_user_table_id,
        selectedStudent.user_id || selectedStudent.stu_id,
        selectedStudent.user_table_id,
        this.state.userType
      )
        .then((res) => {
          this.setState({ enrolledPapers: res.data.enrolledPapers });
        })
        .finally(() => {
          this.setState({ isTableDataLoading: false });
        });
    }
  };

  fetchAllEnrolledChildPapers = async () => {
    this.setState({ isTableDataLoading: true });
    const { lg_user_id } = this.props.state;
    this.setState({ selectedStudent: lg_user_id }, () => {
      this.fetchEnrollPaperData();
    });
    this.setState({ isTableDataLoading: false });
  };

  onFilterInput = (v, r) => {
    let categoryOptions;
    let languageOptions;
    let subjectOptions;
    let authorOptions;
    let gradeOptions;
    let yearOptions;
    let termOptions;
    let chapterOptions;
    let difficultyOptions;
    let selectedFilters = [];
    this.setState({
      filters: v,
      filterValues: [],
    });

    if (r === "removeOption") {
      this.setState(
        {
          selectedAuthors: null,
          selectedsubjects: null,
          selectedChapters: null,
          selectedTerms: null,
          selectedCategories: null,
          selectedYears: null,
          selectedLanguages: null,
          selectedDifficulties: null,
          selectedGrades: null,
        },
        () => {
          this.callAfterSubmit();
        }
      );
    }
    if (v.includes("Category")) {
      categoryOptions = this.state.allCategories?.map((val) => {
        return {
          filter: "Category",
          name: val.name,
          category_id: val.category_id,
        };
      });
      selectedFilters = [...selectedFilters, ...categoryOptions];
    }
    if (v.includes("Language")) {
      languageOptions = this.state.allLanguages?.map((val) => {
        return {
          filter: "Language",
          name: val.language,
          language_id: val.language_id,
        };
      });
      selectedFilters = [...selectedFilters, ...languageOptions];
    }
    if (v.includes("Subject")) {
      subjectOptions = this.state.allSubjects?.map((val) => {
        return {
          filter: "Subject",
          name: val.subject,
          subject_id: val.subject_id,
        };
      });
      selectedFilters = [...selectedFilters, ...subjectOptions];
    }
    if (v.includes("Author")) {
      authorOptions = this.state.allAuthors?.map((val) => {
        return {
          filter: "Author",
          name: val.author,
          author_id: val.author_id,
        };
      });
      selectedFilters = [...selectedFilters, ...authorOptions];
    }
    if (v.includes("Year")) {
      yearOptions = this.state.allYears?.map((val) => {
        return {
          filter: "Year",
          name: val.year,
          year_id: val.year_id,
        };
      });
      selectedFilters = [...selectedFilters, ...yearOptions];
    }
    if (v.includes("Difficulty")) {
      difficultyOptions = this.state.allDifficulties?.map((val) => {
        return {
          filter: "Difficulty",
          name: val.difficulty_type,
          difficulty_id: val.difficulty_id,
        };
      });
      selectedFilters = [...selectedFilters, ...difficultyOptions];
    }
    if (v.includes("Grade")) {
      gradeOptions = this.state.allGrades?.map((val) => {
        return {
          filter: "Grade",
          name: val.grade,
          grade_id: val.grade_id,
        };
      });
      selectedFilters = [...selectedFilters, ...gradeOptions];
    }
    if (v.includes("Term")) {
      termOptions = this.state.allTerms?.map((val) => {
        return {
          filter: "Term",
          name: val.term,
          term_id: val.term_id,
        };
      });
      selectedFilters = [...selectedFilters, ...termOptions];
    }
    if (v.includes("Chapter")) {
      chapterOptions = this.state.allChapters?.map((val) => {
        return {
          filter: "Chapter",
          name: val.chapter,
          chapter_id: val.chapter_id,
        };
      });
      selectedFilters = [...selectedFilters, ...chapterOptions];
    }
    this.setState({
      selectedFilters: selectedFilters,
    });
  };

  onSelectFilter = (e) => {
    let selectedGrades = [];
    let selectedChapters = [];
    let selectedsubjects = [];
    let selectedAuthors = [];
    let selectedYears = [];
    let selectedCategories = [];
    let selectedTerms = [];
    let selectedDifficulties = [];
    let selectedLanguages = [];

    e.map((val) => {
      if (val.filter === "Category") {
        selectedCategories.push(val?.category_id);
      }
      if (val.filter === "Difficulty") {
        selectedDifficulties.push(val?.difficulty_id);
      }
      if (val.filter === "Language") {
        selectedLanguages.push(val?.language_id);
      }
      if (val.filter === "Subject") {
        selectedsubjects.push(val?.subject_id);
      }
      if (val.filter === "Author") {
        selectedAuthors.push(val?.author_id);
      }
      if (val.filter === "Year") {
        selectedYears.push(val?.year_id);
      }
      if (val.filter === "Term") {
        selectedTerms.push(val?.term_id);
      }
      if (val.filter === "Chapter") {
        selectedChapters.push(val?.chapter_id);
      }
      if (val.filter === "Grade") {
        selectedGrades.push(val?.grade_id);
      }
    });

    this.setState(
      {
        filterValues: e,
        selectedAuthors: selectedAuthors.length > 0 ? selectedAuthors : null,
        selectedsubjects: selectedsubjects.length > 0 ? selectedsubjects : null,
        selectedChapters: selectedChapters.length > 0 ? selectedChapters : null,
        selectedTerms: selectedTerms.length > 0 ? selectedTerms : null,
        selectedCategories:
          selectedCategories.length > 0 ? selectedCategories : null,
        selectedYears: selectedYears.length > 0 ? selectedYears : null,
        selectedLanguages:
          selectedLanguages.length > 0 ? selectedLanguages : null,
        selectedDifficulties:
          selectedDifficulties.length > 0 ? selectedDifficulties : null,
        selectedGrades: selectedGrades.length > 0 ? selectedGrades : null,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  toggleAddEnrollModal = (asses_id, assess_name, grade_id) => {
    const { userType } = this.state;

    this.setState(
      (prevState) => ({
        showInsertModal: !prevState.showInsertModal,
        asses_id: asses_id,
        assess_name: assess_name,
        grade_id: grade_id,
        selectedCredit: null,
        isCreditNotAvailable: false,
      }),
      () => {
        if (this.state.showInsertModal) {
          if (userType === "student") {
            this.getAllEnrollCredits();
          } else if (userType === "parent" || userType === "admin") {
            this.getAllEnrollCreditsForParent();
          }
        } else {
          this.setState({ selectedCredit: null, grade_id: "" });
        }
      }
    );
  };

  toggleAddExamEnrollModal = async (assess_credits, asses_id, assess_name, grade_id) => {
    let response = await libraryService.viewAssessmentData(asses_id);
    this.setState({ examData: response.data.view_assessment_data || [] });
    const { userType, selectedStudent } = this.state;

    this.setState(
      (prevState) => ({
        showCreditInsertModal: !prevState.showCreditInsertModal,
        asses_id: asses_id,
        assess_name: assess_name,
        grade_id: grade_id,
        assess_credits: assess_credits,
        selectedCredit: null,
        isCreditNotAvailable: false,
      }),
      () => {
        if (this.state.showCreditInsertModal) {
          if (userType === "student") {
            this.getAllExamEnrollCredits(sessionStorage.getItem("manage_user_id"), userType);
          }
          if (userType === "parent") {
            const studentId = selectedStudent?.user_id || selectedStudent?.stu_id;
            if (studentId) {
              this.getAllExamEnrollCredits(studentId, userType);
            }
          }
        }
        else {
          this.setState({ selectedCredit: null, grade_id: "" });
        }
      }
    );
  };

  toggleAddExamBuyModal = async (assessment_id, assess_name, credit_purchase_flag, amount_purchase_flag, no_of_credits, amount, amount_currency_type_id) => {
    let response = await libraryService.viewAssessmentData(assessment_id);
    this.setState({ examData: response.data.view_assessment_data || [] });
    this.setState(
      (prevState) => ({
        showCreditBuyModal: !prevState.showCreshowCreditBuyModalditBuyModal,
        assess_name: assess_name,
        asses_id: assessment_id,
        credit_purchase_flag: credit_purchase_flag,
        amount_purchase_flag: amount_purchase_flag,
        no_of_credits: no_of_credits,
        amount: amount,
        amount_currency_type_id: amount_currency_type_id,
      }));
  };

  handleChangeCredit = (event) => {
    const { name, value } = event.target;
    const { credits } = this.state;

    const selectedCredit = credits.find(
      (credit) => credit.credit_id === parseInt(value)
    );

    this.setState({ selectedCredit: selectedCredit, isModified: true }, () => {
      if (this.state.selectedCredit) {
        if (this.state.selectedCredit.available_credits <= 0) {
          this.setState({ isCreditNotAvailable: true });
        } else {
          this.setState({ isCreditNotAvailable: false });
        }
      } else {
        this.setState({ selectedCredit: null });
      }
    });
  };

  handleChangeExamCredit = (event) => {
    const { name, value } = event.target;
    const { creditsAssessments } = this.state;
    const selectedCredit = creditsAssessments.find(
      (credit) => credit.credit_package_id || 0 === parseInt(value)
    );
    this.setState({ selectedCredit: selectedCredit, isModified: true }, () => {
      if (this.state.selectedCredit) {
        if (this.state.selectedCredit.available_credits <= 0) {
          this.setState({ isCreditNotAvailable: true });
        } else {
          this.setState({ isCreditNotAvailable: false });
        }
      } else {
        this.setState({ selectedCredit: null });
      }
    });
  };

  getAllEnrollCredits() {
    this.setState({
      is_level_price_loading: true,
      creditsLoading: true,
    });

    let mid = 100;
    const { grade_id } = this.state;

    const UserId = sessionStorage.getItem("manage_user_id");
    CreditService.getAllCreditsForPaperEnrollment(mid, UserId, grade_id)
      .then((res) => {
        if (res.success) {
          this.setState({ credits: res.data.credits });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Credits. Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          is_level_price_loading: false,
          creditsLoading: false,
        });
      });
  }

  getAllExamEnrollCredits(UserId, userType) {
    this.setState({
      is_level_price_loading: true,
      creditsLoading: true,
    });

    let mid = 100;
    AssessmentCreditService.getAllExamCreditsForPaperEnrollment(mid, UserId, userType)
      .then((res) => {
        if (res.success) {
          this.setState({ creditsAssessments: res.data.credits });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Credits. Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          is_level_price_loading: false,
          creditsLoading: false,
        });
      });
  }

  fetchCreditCategory = async (grade_id, subject_id, language_id, exam_category_id) => {
    try {
      this.setState({
        is_level_price_loading: true,
        creditsLoading: true,
      });
      const Ids = {
        grade_id: grade_id,
        subject_id: subject_id,
        language_id: language_id,
        exam_category_id: exam_category_id,
        status: 'Active'
      }

      const creditCategoryResponse = await creditCategoryService.getCreditCategory(Ids);
      if (creditCategoryResponse.success) {
        this.setState({
          assessmentCredits: creditCategoryResponse.data[0]
        });
      } else {
        this.setState({
          assessmentCredits: null,
        });
      }
    } catch (error) {
      console.error("Error fetching credit category data:", error);
      this.setState({
        assessmentCredits: null,
      });
    } finally {
      this.setState({
        is_level_price_loading: false,
        creditsLoading: false,
      });
    }
  };

  getAllEnrollCreditsForParent() {
    this.setState({
      is_level_price_loading: true,
      creditsLoading: true,
    });

    // const { mid } = this.props.state;
    let mid = 100;
    const { grade_id } = this.state;

    const UserId = this.state.selectedStudent ? this.state.selectedStudent.userId || this.state.selectedStudent.stu_id : null;
    CreditService.getAllParentCreditsForPaperEnrollment(mid, UserId, grade_id)
      .then((res) => {
        if (res.success) {
          this.setState({ credits: res.data.credits });
        } else {
          sweetStatusAlert(
            "Failed!",
            "Error fetching Credits. Please refresh the screen!",
            "error"
          );
        }
      })
      .finally(() => {
        this.setState({
          is_level_price_loading: false,
          creditsLoading: false,
        });
      });
  }

  redirectToSubscriptions() {
    const state = {
      privilege_edit: 1,
      privilege_add: 1,
      privilege_delete: 1,
      nodeTitle: 'Subscriptions',
      mid: 100,
      main_table_id: 10,
      owner_restriction: null,
      lg_user_id: sessionStorage.getItem("manage_user_id"),
      lg_user_table_id: sessionStorage.getItem("table_log_id"),
      user_list_restriction: null,
      flg_list_active: 1,
      form_list_id: 46,
      tab_param: 1
    };

    history.push({
      pathname: routes.assess_subscriptions,
      state: { ...state },
    });
  }

  // NEw functions

  onSelectFilterMulti = (selectedItem) => {

    const { filterValues } = this.state;

    let updatedFilterValues = [...filterValues];

    const index = updatedFilterValues.findIndex(
      (item) =>
        item.filter === selectedItem.filter &&
        item[`${selectedItem.filter.toLowerCase()}_id`] === selectedItem[`${selectedItem.filter.toLowerCase()}_id`]
    );


    if (index === -1) {

      updatedFilterValues.push(selectedItem);

    } else {

      updatedFilterValues.splice(index, 1);
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  onSelectFilterMultiProcess = (filterValues) => {

    const filterMap = {
      Category: [],
      Difficulty: [],
      Language: [],
      Subject: [],
      Author: [],
      Year: [],
      Term: [],
      Chapter: [],
      Grade: []
    };

    filterValues.forEach((val) => {
      const filterType = val.filter;
      if (filterType && filterMap.hasOwnProperty(filterType)) {
        switch (filterType) {
          case "Category":
            filterMap.Category.push(val?.category_id);
            break;
          case "Difficulty":
            filterMap.Difficulty.push(val?.difficulty_id);
            break;
          case "Language":
            filterMap.Language.push(val?.language_id);
            break;
          case "Subject":
            filterMap.Subject.push(val?.subject_id);
            break;
          case "Author":
            filterMap.Author.push(val?.author_id);
            break;
          case "Year":
            filterMap.Year.push(val?.year_id);
            break;
          case "Term":
            filterMap.Term.push(val?.term_id);
            break;
          case "Chapter":
            filterMap.Chapter.push(val?.chapter_id);
            break;
          case "Grade":
            filterMap.Grade.push(val?.grade_id);
            break;
          default:
            break;
        }
      }
    });

    this.setState(
      {
        filterValues,
        selectedAuthors: filterMap.Author.length > 0 ? filterMap.Author : null,
        selectedsubjects: filterMap.Subject.length > 0 ? filterMap.Subject : null,
        selectedChapters: filterMap.Chapter.length > 0 ? filterMap.Chapter : null,
        selectedTerms: filterMap.Term.length > 0 ? filterMap.Term : null,
        selectedCategories:
          filterMap.Category.length > 0 ? filterMap.Category : null,
        selectedYears: filterMap.Year.length > 0 ? filterMap.Year : null,
        selectedLanguages:
          filterMap.Language.length > 0 ? filterMap.Language : null,
        selectedDifficulties:
          filterMap.Difficulty.length > 0 ? filterMap.Difficulty : null,
        selectedGrades: filterMap.Grade.length > 0 ? filterMap.Grade : null
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  isParentChecked = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    return (
      childItems.length > 0 &&
      childItems.every((child) =>
        filterValues.some(
          (selectedItem) =>
            selectedItem.filter === filterType &&
            selectedItem[`${filterType.toLowerCase()}_id`] ===
            child[`${filterType.toLowerCase()}_id`]
        )
      )
    );
  };

  isParentIndeterminate = (filterType) => {
    const filterValues = this.state.filterValues;
    const childItems = this.getChildItems(filterType);
    const selectedCount = childItems.filter((child) =>
      filterValues.some(
        (selectedItem) =>
          selectedItem.filter === filterType &&
          selectedItem[`${filterType.toLowerCase()}_id`] ===
          child[`${filterType.toLowerCase()}_id`]
      )
    ).length;
    return selectedCount > 0 && selectedCount < childItems.length;
  };

  handleParentCheckboxChange = (filterType, filterItems) => {
    const filterValues = [...this.state.filterValues];
    const childItems = filterItems

    const allSelected = this.isParentChecked(filterType);

    let updatedFilterValues;
    if (allSelected) {

      updatedFilterValues = filterValues.filter(
        (item) => item.filter !== filterType
      );
    } else {

      const newSelections = childItems.map((child) => ({
        filter: filterType,
        name: child.name,
        [`${filterType.toLowerCase()}_id`]: child[`${filterType.toLowerCase()}_id`],
      }));

      updatedFilterValues = [
        ...filterValues.filter((item) => item.filter !== filterType),
        ...newSelections,
      ];
    }


    this.onSelectFilterMultiProcess(updatedFilterValues);
  };

  getChildItems = (filterType) => {

    switch (filterType) {
      case "Category":
        return this.state.allCategories || [];
      case "Difficulty":
        return this.state.allDifficulties || [];
      case "Language":
        return this.state.allLanguages || [];
      case "Subject":
        return this.state.allSubjects || [];
      case "Author":
        return this.state.allAuthors || [];
      case "Year":
        return this.state.allYears || [];
      case "Grade":
        return this.state.allGrades || [];
      case "Term":
        return this.state.allTerms || [];
      case "Chapter":
        return this.state.allChapters || [];
      default:
        return [];
    }
  };

  clearAllFilters = () => {
    this.setState(
      {
        filterValues: [],
        selectedAuthors: null,
        selectedsubjects: null,
        selectedChapters: null,
        selectedTerms: null,
        selectedCategories: null,
        selectedYears: null,
        selectedLanguages: null,
        selectedDifficulties: null,
        selectedGrades: null
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };

  findLanguage = (language_id) => {
    const { allLanguages } = this.state
    if (allLanguages && allLanguages.length > 0) {

      const paperLanguage = allLanguages.find((language) => language.language_id === parseInt(language_id));

      return paperLanguage ? String(paperLanguage.language) : "N/A"
    }
    else {
      return "N/A"
    }
  }

  handleFilterChange = (newSelectedFilters) => {

    const getOrNull = (key) =>
      newSelectedFilters[key] && newSelectedFilters[key].length > 0
        ? newSelectedFilters[key]
        : null;

    this.setState(
      {
        selectedCategories: getOrNull("Exam_Category"),
        selectedAuthors: getOrNull("Author"),
        selectedChapters: getOrNull("Chapter"),
        selectedDifficulties: getOrNull("Difficulty"),
        selectedGrades: getOrNull("Grade"),
        selectedLanguages: getOrNull("Language"),
        selectedTerms: getOrNull("Term"),
        selectedYears: getOrNull("Year"),
        selectedsubjects: getOrNull("Subject"),
        selectedStartDate: getOrNull("StartDate"),
        selectedEndDate: getOrNull("EndDate"),

        offset: 0,
        currentPage: 0,
      },
      () => {
        this.callAfterSubmit();
      }
    );
  };


  render() {
    const {
      examData,
      papers,
      totalPapers,
      selectedStudent,
      studentlist,
      isSpinnerLoading,
      creditsLoading,
      isTableDataLoading,
      enrolledPapers,
      limit,
      currentPage,
      editVisibility,
      creditsAssessments,
      assessmentCredits,
      addVisibility,
      assess_credits,
      isDropHidden,
      userType,
      credits,
      isCreditNotAvailable,
      selectedCredit,
      offset,
      isGradeLoading,
      isSubjectLoading,
      isYearLoading
    } = this.state;
    const path = history.location.pathname;



    return (
      <>
        <ContentWrapper disabled={path === "/manage-search"}>
          <div className="thepapers-wrapper">
            <div className="col-md-12 px-0">
              <div className="row mt-0">
                {/* Filter section at top, full width */}
                <div className="col-md-12 px-0 mb-4">
                  <div className="filter-container-top">
                    {/* Select Student section for parent */}
                    {this.state.userType === "parent" && this.state.isDropHidden && (
                      <div className="student-select-wrap mb-3">
                        <div className="student-select-inner">
                          <Form.Group
                            as={Col}
                            md="12"
                            controlId="exampleForm.ControlInput3"
                            className="mb-0 px-0"
                          >
                            <Form.Select
                              aria-label="Select the student"
                              name="student_id"
                              value={
                                (this.state.selectedStudent?.user_id ||
                                  this.state.selectedStudent?.stu_id ||
                                  '')
                              }
                              onChange={this.handleStudentSelect}
                            >
                              <option value="" style={{ fontFamily: "Inter, sans-serif" }}>
                                Select Student
                              </option>
                              {this.state.studentlist.map((student) => (
                                <option
                                  key={student.user_id || student.stu_id}
                                  value={student.user_id || student.stu_id}
                                >
                                  {`${student.first_name} ${student.last_name}`}
                                </option>
                              ))}
                            </Form.Select>
                          </Form.Group>
                        </div>
                      </div>
                    )}

                    {/* Filter layout section */}
                    <div className="col-md-12 px-0">
                      <PaperFilterLayout
                        userType={this.state.userType}
                        onFilterChange={this.handleFilterChange}
                        filterKeys={ASSESSMENT_STUDENT_FILTERS}
                        isShowExamStatus={false}
                        showHeader={this.props.showHeader || false}
                        value={this.props.value}
                        handleChange={this.props.handleChange}
                        customerPaperText={this.props.customerPaperText}
                        availablePaperControl={this.props.availablePaperControl}
                        enrollPaperControl={this.props.enrollPaperControl}
                      />
                    </div>
                  </div>
                </div>

                {/* Papers section - now full width */}
                <div className="col-md-12 px-0">
                  {isSpinnerLoading && (
                    <PageSpinner id="payment" text="Loading, Please wait!" />
                  )}
                  {(isGradeLoading || isSubjectLoading || isYearLoading) && (
                    <div>
                      <div className="loading-container mb-5 mt-10">
                        <ReactSpinner
                          animation="border"
                          role="status"
                          style={{ display: "block", margin: "auto" }}
                        >
                          <span className="sr-only">Loading...</span>
                        </ReactSpinner>
                      </div>
                    </div>
                  )}
                  {
                    isTableDataLoading ? (
                      <div>
                        <div className="loading-container mb-5 mt-10">
                          <ReactSpinner
                            animation="border"
                            role="status"
                            style={{ display: "block", margin: "auto" }}
                          >
                            <span className="sr-only">Loading...</span>
                          </ReactSpinner>
                        </div>
                      </div>
                    ) : selectedStudent || !isDropHidden ? (
                      <div
                        style={{
                          overflowY: "auto",
                          overflowX: "auto",
                        }}
                      >
                        {/* Card list view */}
                        <div className="ph-paper-table-wrapper">
                          <div className="row" style={{ minHeight: 'auto', alignContent: 'flex-start' }}>
                            {papers.map((paper) => {
                              const enrolledExam = enrolledPapers?.find((exam) => {
                                if (userType === "student") {
                                  return exam.assessment_id === paper.assessment_id;
                                }
                                return (
                                  exam.assessment_id === paper.assessment_id &&
                                  (
                                    exam.enroll_user_id === parseInt(this.state.selectedStudent?.user_id) ||
                                    exam.enroll_user_id === parseInt(this.state.selectedStudent?.stu_id)
                                  )
                                );
                              });

                              // credit/fee label (matches your original rules)
                              const creditLabel =
                                (paper.credit_purchase_flag === 0 && paper.amount_purchase_flag === 0 && !paper.no_of_credits)
                                  ? "Credits 1"
                                  : (paper.credit_purchase_flag === 1 && !!paper.no_of_credits)
                                    ? `Credits ${paper.no_of_credits}`
                                    : (paper.amount_purchase_flag === 1 && paper.amount != null && !paper.no_of_credits)
                                      ? "Paid Only"
                                      : "N/A";

                              return (
                                <div className="col-12 mb-3" key={paper.id}>
                                  <div className="card ph-paper-card shadow-sm">
                                    <div className="ph-ppr-card-body">
                                      <div className="row align-items-center">
                                        {/* Paper Title */}
                                        <div className="col-12 col-lg-6 col-md-5 mb-md-0">
                                          <div className="ph-paper-info">
                                            <h6 className="ph-paper-title">{paper.assess_name}</h6>
                                          </div>
                                        </div>

                                        {/* Credit Badge */}
                                        <div className="col-6 col-lg-2 col-md-3 mb-md-0 d-flex justify-content-md-center justify-content-start">
                                          <div className="ph-paper-credit-value">
                                            {creditLabel}
                                          </div>
                                        </div>
                                        {/* Action Buttons */}
                                        <div className="col-6 col-lg-4 col-md-4 d-flex justify-content-end mb-md-0">
                                          <div className="ph-paper-action">
                                            {enrolledExam ? (
                                              <Tooltip
                                                title={
                                                  <React.Fragment>
                                                    <Typography color="inherit" sx={{ fontSize: 12 }}>
                                                      Select{' '}
                                                      <span
                                                        onClick={() => this.props.handleChange(null, 1)}
                                                        style={{
                                                          color: '#ffc83c',
                                                          textDecoration: 'underline',
                                                          cursor: 'pointer',
                                                        }}
                                                      >
                                                        <b><u>Enrolled Exams</u></b>
                                                      </span>{' '}
                                                      tab to see the exam
                                                    </Typography>
                                                  </React.Fragment>
                                                }
                                                arrow
                                                placement="top"
                                                PopperProps={{ sx: { '& .MuiTooltip-tooltip': { fontSize: '12px' } } }}
                                              >
                                                <button
                                                  className="ph-paper-btn ph-paper-btn-success-filled"
                                                  onClick={() => this.props.handleChange(null, 1)}
                                                  aria-label="Enrolled"
                                                >
                                                  <CheckCircleOutlineIcon fontSize="small" />
                                                  <span style={{ marginLeft: 0 }}>Enrolled</span>
                                                </button>
                                              </Tooltip>
                                            ) : (
                                              <>
                                                {/* Enroll with Credits Button */}
                                                {(paper.amount_purchase_flag === 0 && paper.credit_purchase_flag === 0 && !paper.no_of_credits) && (
                                                  <Tooltip
                                                    title="Use your pre-purchased credits to enroll"
                                                    placement="top"
                                                    arrow
                                                    PopperProps={{ sx: { '& .MuiTooltip-tooltip': { fontSize: '12px' } } }}
                                                  >
                                                    <button
                                                      className="ph-paper-btn ph-paper-btn-secondary"
                                                      onClick={() =>
                                                        this.toggleAddExamEnrollModal(
                                                          1,
                                                          paper.assessment_id,
                                                          paper.assess_name,
                                                          paper.grade_id
                                                        )
                                                      }
                                                    >
                                                      <GoCheckbox />
                                                      Enroll with Credits
                                                    </button>
                                                  </Tooltip>
                                                )}

                                                {(paper.credit_purchase_flag === 1 && paper.no_of_credits) && (
                                                  <Tooltip
                                                    title="Use your pre-purchased credits to enroll"
                                                    placement="top"
                                                    arrow
                                                    PopperProps={{ sx: { '& .MuiTooltip-tooltip': { fontSize: '12px' } } }}
                                                  >
                                                    <button
                                                      className="ph-paper-btn ph-paper-btn-secondary"
                                                      onClick={() =>
                                                        this.toggleAddExamEnrollModal(
                                                          paper.no_of_credits,
                                                          paper.assessment_id,
                                                          paper.assess_name,
                                                          paper.grade_id
                                                        )
                                                      }
                                                    >
                                                      <GoCheckbox />
                                                      Enroll with Credits
                                                    </button>
                                                  </Tooltip>
                                                )}

                                                {/* Purchase Exam Button */}
                                                {(paper.amount_purchase_flag === 1 && paper.amount) && (
                                                  <Tooltip
                                                    title="Purchase this exam to enroll"
                                                    placement="top"
                                                    arrow
                                                    PopperProps={{ sx: { '& .MuiTooltip-tooltip': { fontSize: '12px' } } }}
                                                  >
                                                    <button
                                                      className="ph-paper-btn ph-paper-btn-primary"
                                                      onClick={() =>
                                                        this.toggleAddExamBuyModal(
                                                          paper.assessment_id,
                                                          paper.assess_name,
                                                          paper.credit_purchase_flag,
                                                          paper.amount_purchase_flag,
                                                          paper.no_of_credits,
                                                          paper.amount,
                                                          paper.amount_currency_type_id
                                                        )
                                                      }
                                                    >
                                                      <LocalMallOutlinedIcon />
                                                      Purchase Exam
                                                    </button>
                                                  </Tooltip>
                                                )}
                                              </>
                                            )}

                                            {/* Admin View Button */}
                                            {userType === "admin" && (
                                              <Tooltip title="View Paper Details" placement="top" arrow>
                                                <button
                                                  onClick={(e) => this.handleViewClick(e, paper)}
                                                  className="ph-paper-btn ph-paper-btn-icon"
                                                >
                                                  <i className="flaticon-eye"></i>
                                                </button>
                                              </Tooltip>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </div>

                          <hr className="ph-divider" />

                          {/* pagination component */}
                          <MaterialCustomTablePagination
                            totalCount={parseInt(totalPapers)}
                            currentPage={currentPage}
                            limit={limit}
                            handlePageChange={this.handlePageChange}
                            handleRowsPerPageChange={this.handleRowsPerPageChange}
                            handlePageOffsetChange={this.handlePageOffsetChange}
                            rowsPerPageOptions={[5, 10, 20]}
                            offset={offset}
                          />
                        </div>


                      </div>
                    ) : null /* Render nothing if no student is selected */
                  }
                </div>
              </div>
            </div>
          </div>
          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showCreditInsertModal}
            onHide={() => this.setState({
              showCreditInsertModal: false,
              selectedCredits: [],
              totalSelectedCredits: 0,
              isCreditSufficient: false,
              isCreditNotAvailable: false,
            })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Let's Enroll for the Exam.</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group as={Col} md="12" controlId="exampleForm.ControlInput1">
                    {this.state.examData && this.state.examData.length > 0 && (
                      <div className="exam-details-card">
                        <div className="exam-details-card__heading">
                          <span className="exam-details-card__eyebrow">Exam Details</span>
                        </div>
                        <div className="exam-details-grid">
                          <div className="exam-details-item">
                            <span className="exam-details-label">Exam Name</span>
                            <span className="exam-details-value">
                              {this.state.examData[0].assessment.title || "N/A"}
                            </span>
                          </div>
                          <div className="exam-details-item">
                            <span className="exam-details-label">Subject</span>
                            <span className="exam-details-value">
                              {this.state.allSubjects.find(
                                (s) => s.subject_id == this.state.examData[0].assessment.subject_id
                              )?.subject || "N/A"}
                            </span>
                          </div>
                          <div className="exam-details-item">
                            <span className="exam-details-label">Grade</span>
                            <span className="exam-details-value">
                              {this.state.allGrades.find(
                                (g) => g.grade_id == this.state.examData[0].assessment.grade_id
                              )?.grade || "N/A"}
                            </span>
                          </div>
                          <div className="exam-details-item">
                            <span className="exam-details-label">Language</span>
                            <span className="exam-details-value">
                              {this.state.allLanguages.find(
                                (l) => l.language_id == this.state.examData[0].assessment.language_id
                              )?.language || "N/A"}
                            </span>
                          </div>
                          {this.state.examData[0].assessment.difficulty_id !== null && (
                            <div className="exam-details-item">
                              <span className="exam-details-label">Difficulty</span>
                              <span className="exam-details-value">
                                {this.state.allDifficulties.find(
                                  (d) =>
                                    d.difficulty_id == this.state.examData[0].assessment.difficulty_id
                                )?.difficulty_type || "N/A"}
                              </span>
                            </div>
                          )}
                          {this.state.examData[0].assessment.exam_category_id !== null && (
                            <div className="exam-details-item">
                              <span className="exam-details-label">Exam Category</span>
                              <span className="exam-details-value">
                                {this.state.allCategories.find(
                                  (c) =>
                                    c.category_id == this.state.examData[0].assessment.exam_category_id
                                )?.name || "N/A"}
                              </span>
                            </div>
                          )}
                          <div className="exam-details-item">
                            <span className="exam-details-label">Time Duration</span>
                            <span className="exam-details-value">
                              {this.state.examData[2]?.schedule[0].exam_time_interval !== null
                                ? this.convertTestDurationInSelectedUnit(
                                  this.state.examData[2]?.schedule[0].exam_time_interval
                                )
                                : "Unlimited"}
                            </span>
                          </div>
                        </div>
                      </div>
                    )}

                    <div className="exam-credits-callout">
                      <p className="exam-credits-callout__primary">
                        You need <span>{assess_credits}</span> credits to enroll for the selected exam.
                      </p>
                      {creditsAssessments.length > 0 && (
                        <p className="exam-credits-callout__secondary">
                          Choose the credit packages that cover this requirement.
                        </p>
                      )}
                    </div>

                    {creditsAssessments.length > 0 &&
                      this.state.selectedCredits.length > 0 &&
                      this.state.totalSelectedCredits < assess_credits && (
                        <div className="credit-feedback credit-feedback--error">
                          Selected packages have insufficient credits. You need{' '}
                          {Math.max(0, assess_credits - this.state.totalSelectedCredits)} more credits.
                        </div>
                      )}

                    {this.state.isCreditSufficient && (
                      <div className="credit-feedback credit-feedback--success">
                        You're ready! Enough credits are selected.
                      </div>
                    )}

                    {creditsLoading ? (
                      <div className="credit-packages-loading">
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <div className="credit-packages-grid">
                        {creditsAssessments.length > 0 ? (
                          creditsAssessments.map((credit) => {
                            let isSelected = this.state.selectedCredits.some(
                              (c) => c.exam_credit_id === credit.exam_credit_id
                            );
                            let willExceedRequired =
                              this.state.totalSelectedCredits >= assess_credits && !isSelected;

                            return (
                              <Sheet
                                key={credit.exam_credit_id}
                                variant="outlined"
                                className={`credit-package-card${isSelected ? " credit-package-card--selected" : ""}${willExceedRequired ? " credit-package-card--locked" : ""
                                  }`}
                                onClick={() => {
                                  if (willExceedRequired && !isSelected) {
                                    return;
                                  }

                                  this.handleToggleCredit(
                                    { target: { checked: !isSelected } },
                                    credit
                                  );
                                }}
                                sx={{
                                  borderRadius: "18px",
                                  border: "1px solid",
                                  borderColor: isSelected ? "#7F56D9" : "#E4E7EC",
                                  backgroundColor: isSelected ? "#F9F5FF" : "#FFFFFF",
                                  boxShadow: isSelected
                                    ? "0 28px 50px -32px rgba(127, 86, 217, 0.4)"
                                    : "0 12px 32px -28px rgba(15, 23, 42, 0.18)",
                                  transition: "all 0.28s ease",
                                  padding: "24px",
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "16px",
                                  minHeight: "100%",
                                  cursor: willExceedRequired && !isSelected ? "not-allowed" : "pointer",
                                  opacity: willExceedRequired && !isSelected ? 0.6 : 1,
                                  '&:hover':
                                    willExceedRequired && !isSelected
                                      ? {}
                                      : {
                                        transform: "translateY(-4px)",
                                        boxShadow: "0 32px 52px -30px rgba(127, 86, 217, 0.35)",
                                      },
                                  '&:focus-visible': {
                                    outline: "none",
                                    boxShadow: "0 0 0 3px rgba(127, 86, 217, 0.2)",
                                  },
                                }}
                              >
                                <div className="credit-package-card__header">
                                  <div>
                                    <p className="credit-package-card__title">
                                      {credit.package_name || "Credit"} Package
                                    </p>
                                    <p className="credit-package-card__subtitle">
                                      {credit.available_credits} credits available
                                    </p>
                                  </div>
                                  <div className="credit-package-card__actions">
                                    <Checkbox
                                      id={`credit-checkbox-${credit.exam_credit_id}`}
                                      name="credits"
                                      value={credit.exam_credit_id}
                                      checked={isSelected}
                                      disabled={willExceedRequired}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        this.handleToggleCredit(e, credit);
                                      }}
                                      onClick={(e) => e.stopPropagation()}
                                      sx={{
                                        '&.Mui-checked': {
                                          color: "#7F56D9",
                                        },
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="credit-package-card__metrics">
                                  <div className="credit-package-card__metric">
                                    <span className="credit-package-card__metric-label">Credits</span>
                                    <span className="credit-package-card__metric-value">
                                      {credit.available_credits}
                                    </span>
                                  </div>
                                  <div className="credit-package-card__metric credit-package-card__metric--muted">
                                    <span className="credit-package-card__metric-label">Expires</span>
                                    <span className="credit-package-card__metric-value">
                                      {TimeZoneHandler.convertTime(credit.expiration_date)}
                                    </span>
                                  </div>
                                  <div className="credit-package-card__metric credit-package-card__metric--muted">
                                    <span className="credit-package-card__metric-label">Paid by</span>
                                    <span className="credit-package-card__metric-value">
                                      {credit.paid_by}
                                    </span>
                                  </div>
                                </div>
                              </Sheet>
                            );
                          })
                        ) : !this.state.is_level_price_loading ? (
                          <div className="credit-packages-empty">
                            <p className="credit-packages-empty__title">
                              You don't have credits for this exam yet.
                            </p>
                            <p className="credit-packages-empty__copy">
                              Purchase a credit package to unlock enrollment.
                            </p>
                            <Button
                              className="modal-btn eds-modal-enroll-btn credit-packages-empty__cta"
                              onClick={() => this.redirectToSubscriptions()}
                            >
                              Buy Credits
                            </Button>
                          </div>
                        ) : null}
                      </div>
                    )}

                    <div className="credit-validation-message">{/* validation errors here */}</div>
                  </Form.Group>

                  {this.state.isCreditNotAvailable && (
                    <div
                      className="col-md-6"
                      style={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'end',
                        color: 'red',
                      }}
                    >
                      <p>No Credits Available!</p>
                      <p>
                        Please subscribe to a suitable credit package to enroll for this paper.
                      </p>
                      <br />
                      <Button
                        className="modal-btn"
                        variant="primary"
                        onClick={() => this.redirectToSubscriptions()}
                      >
                        Subscriptions
                      </Button>
                    </div>
                  )}
                </Row>

                <Modal.Footer>
                  <Button
                    className={`modal-btn eds-modal-close-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-close' : ''}`}
                    onClick={() =>
                      this.setState({
                        showCreditInsertModal: false,
                        selectedCredits: [],
                        totalSelectedCredits: 0,
                        isCreditSufficient: false,
                        isCreditNotAvailable: false,
                      })
                    }
                  >
                    Close
                  </Button>

                  <Button
                    className={`modal-btn eds-modal-enroll-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-enroll' : ''}`}
                    disabled={
                      this.state.isCreditNotAvailable ||
                      this.state.selectedCredits.length === 0 ||
                      !this.state.isCreditSufficient
                    }
                    onClick={() =>
                      this.toggleExamEnrollModal(
                        this.state.asses_id,
                        this.state.assess_name,
                        assess_credits
                      )
                    }
                  >
                    Enroll
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showInsertModal}
            onHide={() => this.setState({ showInsertModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Select The Credit To Enroll</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    <Form.Label>Available Credit Packages*</Form.Label>
                    {creditsLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "25vh !important",
                        }}
                      >
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <div className="pt-2">
                        {credits.length > 0
                          ? credits.map((credit) => (
                            <Sheet
                              key={credit.credit_id}
                              variant="outlined"
                              sx={{
                                borderRadius: 'md',
                                boxShadow: 'sm',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 1.5,
                                p: 2,
                                mb: 2, // Add margin-bottom to separate each item
                                transition: 'background-color 0.3s, border-color 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                  backgroundColor: 'primary.50', // Background color change on hover
                                  boxShadow: 'md',
                                  borderColor: 'primary.500',
                                },
                              }}
                            >
                              <Radio
                                id={`credit-radio-${credit.credit_id}`}
                                name="credits"
                                value={credit.credit_id}
                                label={`${credit.level_price_name} - ${credit.type_name}`}
                                checked={this.state.selectedCredit && this.state.selectedCredit.credit_id === credit.credit_id}
                                onChange={(e) => this.handleChangeCredit(e)}
                                checkedIcon={<CheckCircleRoundedIcon />}
                                slotProps={{
                                  label: ({ checked }) => ({
                                    sx: {
                                      fontWeight: 'lg',
                                      fontSize: 'md',
                                      color: checked ? 'text.primary' : 'text.secondary',
                                    },
                                  }),
                                  action: ({ checked }) => ({
                                    sx: (theme) => ({
                                      ...(checked && {
                                        '--variant-borderWidth': '2px',
                                        '&&': {
                                          borderColor: theme.vars.palette.primary[500],
                                        },
                                      }),
                                    }),
                                  }),
                                }}
                              />
                              <span>
                                Available Credits - <b>{credit.available_credits}</b>
                              </span>
                              <span>
                                Expiration Date - <b>{TimeZoneHandler.convertTime(credit.expiration_date)}</b>
                              </span>
                              <span>
                                Paid by - <b>{credit.paid_by}</b>
                              </span>
                            </Sheet>
                          ))
                          : !this.state.is_level_price_loading && (
                            <div>
                              You need credits to enroll.
                              <br />
                              <Button
                                className="modal-btn"
                                variant="primary"
                                onClick={() => this.redirectToSubscriptions()}
                              >
                                Buy Credits
                              </Button>
                            </div>
                          )}
                      </div>
                    )}

                    <div style={{ color: "red" }}>
                      {/* {this.validator.message('level', level_id, 'required')} */}
                    </div>
                  </Form.Group>
                  {this.state.isCreditNotAvailable ? (
                    <div
                      className="col-md-6"
                      style={{
                        display: "flex",
                        justifyContent: "end",
                        alignItems: "end",
                        color: "red",
                      }}
                    >
                      <p>No Credits Available!</p>
                      <p>
                        Please subscribe to a suitable credit package to enroll
                        for this paper.
                      </p>
                      <br></br>
                      <Button
                        className="modal-btn"
                        variant="primary"
                        onClick={() => this.redirectToSubscriptions()}
                      >
                        Subscriptions
                      </Button>
                    </div>
                  ) : (
                    <></>
                  )}
                </Row>

                <Modal.Footer>
                  <Button
                    className={`modal-btn eds-modal-close-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-close' : ''}`}
                    id="modal-close-button"
                    onClick={() => this.setState({ showInsertModal: false })}
                  >
                    Close
                  </Button>

                  <Button
                    className={`modal-btn eds-modal-enroll-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-enroll' : ''}`}
                    variant="primary"
                    disabled={isCreditNotAvailable || selectedCredit == null}
                    onClick={() =>
                      this.toggleEnrollModal(
                        this.state.asses_id,
                        this.state.assess_name
                      )
                    }
                  >
                    Enroll
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={this.state.showCreditBuyModal}
            onHide={() => this.setState({ showCreditBuyModal: false })}
          >
            <Modal.Header closeButton>
              <Modal.Title>Exam Credit Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form>
                <Row className="my-5">
                  <Form.Group
                    as={Col}
                    md="12"
                    controlId="exampleForm.ControlInput1"
                  >
                    {creditsLoading ? (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          height: "25vh !important",
                        }}
                      >
                        <Spinner animation="border" role="status">
                          <span className="sr-only">Loading...</span>
                        </Spinner>
                      </div>
                    ) : (
                      <div className="pt-2">
                        {(
                          <>
                            <Form.Label>
                              Exam Details
                            </Form.Label>
                            {this.state.examData && this.state.examData.length > 0 && (
                              <div className="exam-details-box mb-3">
                                <div><strong>Exam Name:</strong> {this.state.examData[0].assessment.title || "N/A"}</div>
                                <div><strong>Subject:</strong> {this.state.allSubjects.find(s => s.subject_id == this.state.examData[0].assessment.subject_id)?.subject || "N/A"}</div>
                                <div><strong>Grade:</strong> {this.state.allGrades.find(g => g.grade_id == this.state.examData[0].assessment.grade_id)?.grade || "N/A"}</div>
                                <div><strong>Language:</strong> {this.state.allLanguages.find(l => l.language_id == this.state.examData[0].assessment.language_id)?.language || "N/A"}</div>
                                {this.state.examData[0].assessment.difficulty_id !== null &&
                                  <div><strong>Difficulty:</strong> {this.state.allDifficulties.find(d => d.difficulty_id == this.state.examData[0].assessment.difficulty_id)?.difficulty_type || "N/A"}</div>
                                }
                                {this.state.examData[0].assessment.exam_category_id !== null &&
                                  <div><strong>Exam Category:</strong> {this.state.allCategories.find(c => c.category_id == this.state.examData[0].assessment.exam_category_id)?.name || "N/A"}</div>
                                }
                                {this.state.examData[0].assessment.exam_time_interval !== null ?
                                  <div className="inline-flex full-width align-center">
                                    <div><strong>Time Duration :</strong> {this.convertTestDurationInSelectedUnit(this.state.examData[2]?.schedule[0].exam_time_interval)}</div>
                                  </div>
                                  : (
                                    <div className="inline-flex full-width align-center">
                                      <div><strong>Time Duration :</strong> Unlimited</div>
                                    </div>
                                  )
                                }

                              </div>
                            )}
                            <Sheet
                              variant="outlined"
                              sx={{
                                borderRadius: 'md',
                                boxShadow: 'sm',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'flex-start',
                                gap: 1.5,
                                p: 2,
                                mb: 2,
                                transition: 'background-color 0.3s, border-color 0.3s, box-shadow 0.3s',
                                '&:hover': {
                                  backgroundColor: 'primary.50',
                                  boxShadow: 'md',
                                  borderColor: 'primary.500',
                                },
                              }}
                            >
                              <span>
                                Purchase and enroll only for this exam
                              </span>
                              <span>
                                For <b>{this.getCurrencyTypeSymbol(this.state.amount_currency_type_id)} {parseFloat(this.state.amount).toFixed(2)}</b>
                              </span>
                            </Sheet>
                          </>
                        )}
                      </div>
                    )}
                  </Form.Group>
                </Row>
                <Modal.Footer>
                  <div className="w-100 d-flex justify-content-between">
                    <div>
                      <img src={PaymentGateSolutions} className="paymentgateimg" style={{ marginLeft: '1.25rem', paddingBottom: '1rem' }} />
                    </div>
                    <div style={{ display: 'flex', gap: '8px' }}>
                      <Button
                        className={`modal-btn eds-modal-close-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-close' : ''}`}
                        id="modal-close-button"
                        onClick={() => this.setState({ showCreditBuyModal: false })}
                      >
                        Close
                      </Button>

                      <Button
                        className={`modal-btn eds-modal-enroll-btn ${customer === customerConstants.EXO_CUSTOMER2 ? 'cmc-enroll' : ''}`}
                        variant="primary"
                        onClick={() =>
                          this.toggleAssessmentCreditEnrollModal(
                            this.state.asses_id,
                            this.state.no_of_credits,
                            this.state.amount,
                            this.getCurrencyTypeSymbol(this.state.amount_currency_type_id),
                            this.state.amount_currency_type_id,
                            this.getCurrencyTypeName(this.state.amount_currency_type_id)
                          )
                        }
                      >
                        Buy & Enroll
                      </Button>
                    </div>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
            size="lg"
            show={this.state.showDetailModal}
            onHide={this.toggleDetailModal}
          >
            <Modal.Header>
              <h5 className="modal-title">{this.state.selectedPaper?.assess_name}</h5>
              <Button variant="secondary" onClick={this.toggleDetailModal}>
                Close
              </Button>
            </Modal.Header>
            {this.state.selectedPaper && (
              <Modal.Body>
                <div className="form" id="kt_form">
                  {this.state.selectedPaper?.grade_id !== null &&
                    <>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Grade :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperGrade(this.state.selectedPaper?.grade_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.language_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Language :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperLanguage(this.state.selectedPaper?.language_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.difficulty_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Difficulty :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperDifficulty(this.state.selectedPaper?.difficulty_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.chapter_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Chapter/Module/Unit :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperChapter(this.state.selectedPaper?.chapter_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.author_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Author :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperAuthor(this.state.selectedPaper?.author_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.term_id !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Term/Semester :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getPaperTerm(this.state.selectedPaper?.term_id)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.first_name !== null && this.state.selectedPaper?.last_name !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Created By :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.state.selectedPaper?.first_name + " " + this.state.selectedPaper?.last_name}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  {this.state.selectedPaper?.created_at !== null &&
                    <>
                      <div className="separator separator-dashed my-5"></div>
                      <div className="row">
                        <h6 className="font-weight-bolder mb-3 col-md-4">
                          Created At :
                        </h6>
                        <div className="text-dark-50 line-height-lg col-md-5">
                          <div className="inline-flex full-width align-center">
                            {this.getCreatedAtLocal(this.state.selectedPaper?.created_at)}
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </Modal.Body>
            )}
          </Modal>

        </ContentWrapper>
      </>
    );
  }
}
